import React from 'react'

import styled from 'styled-components'

import ColumnItem from './ColumnItem'

import { color } from 'styles/colors'

type Props = React.PropsWithChildren<{
  className?: string
}>

const Column = ({ children, className }: Props) => <S.Column {...{ className }}>{children}</S.Column>
const Header = ({ children, className }: Props) => <S.Header {...{ className }}>{children}</S.Header>

Column.Header = Header
Column.Item = ColumnItem

export default Column

const S = {
  Column: styled.div`
    padding-bottom: 5px;
  `,
  Header: styled.div`
    padding: 9px 5px 9px 15px;
    color: ${color('devicePanelHeader')};
    background-color: ${color('tableHeaderBackground')};
    box-shadow: 0 1px 1px -1px rgb(0 0 0 / 50%);
    font-weight: bold;
  `
}
